"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemePallete = void 0;
var _react = _interopRequireDefault(require("react"));
var _themes = require("./themes");
var _util = require("./util");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ThemePallete = exports.ThemePallete = function ThemePallete(_ref) {
  var setCustomTheme = _ref.setCustomTheme,
    setThemeName = _ref.setThemeName;
  if (APP_MODE === "production") {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "theme-provider-thems",
    style: {
      position: "fixed",
      bottom: 0,
      left: "20px",
      zIndex: 9999,
      backgroundColor: "#FFFFFF",
      padding: "5px"
    },
    "data-sentry-component": "ThemePallete",
    "data-sentry-source-file": "themePallete.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, Object.keys(_themes.Themes).map(function (themeName) {
    var _Themes$themeName;
    return /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        setCustomTheme === null || setCustomTheme === void 0 || setCustomTheme(null);
        setThemeName === null || setThemeName === void 0 || setThemeName(themeName);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        backgroundColor: (_Themes$themeName = _themes.Themes[themeName]) === null || _Themes$themeName === void 0 ? void 0 : _Themes$themeName.primaryBackground,
        border: "1px solid",
        width: 50,
        height: 27,
        cursor: "pointer",
        marginRight: 5
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
    type: "color",
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      return setCustomTheme((0, _util.generateTheme)(target === null || target === void 0 ? void 0 : target.value));
    }
  }))));
};